import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SignupService } from 'src/app/services/signup/signup.service';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnInit {
  @Input() steps: Step[] = [];
  @Input() haveNavigation = false;

  @Input() activeIndex = 0;
  @Input() stepType = 'person';
  @Input() activeSubstepSlug: ComplementaryCompanySteps | PersonSteps =
    'complementaryGeneral';
  @Output() changeActiveStep = new EventEmitter<number>();
  isShareholder: boolean = false;
  isFund: boolean = false;

  constructor(
    private signupService: SignupService,
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isShareholder = this.router.url.includes('shareholder');
    
    // No cadastro básico não precisa verificar isFund (steps são fixos)
    // Se estiver em /basic, pula a verificação completamente
    const url = this.router.url || '';
    if (url.includes('/basic') || url.includes('basic/')) {
      this.isFund = false;
      return;
    }
    
    // Só verifica se o usuário estiver logado e não for cadastro básico
    // Usa try-catch como proteção adicional
    try {
      const user = this.authService.getUser();
      if (user && user.active_register && user.active_register.register && user.active_register.register.role && user.active_register.register.role.slug) {
        this.isFund = user.active_register.register.role.slug.includes('-FI');
      } else {
        this.isFund = false;
      }
    } catch (error) {
      // Se der qualquer erro, assume que não é fundo
      this.isFund = false;
    }
  }

  handlePassedStep(slug: string) {
    const activedIndex = this.steps[0].substeps.findIndex(
      (item) => item.slug === this.activeSubstepSlug
    );

    const slugIndex = this.steps[0].substeps.findIndex(
      (item) => item.slug === slug
    );

    if (activedIndex > slugIndex) {
      return true;
    }

    if (this.activeIndex >= 1) return true;

    return false;
  }

  handleChangeSubStep(substep) {
    const slug = substep.slug.replace('complementary', '');

    this.changeActiveStep.emit(0);

    if (this.stepType === 'person') {
      this.signupService.changePersonStepEvent.emit(slug.toLowerCase());
      this.signupService.setPersonStep(substep.slug);
    } else {
      this.signupService.changeCompanyStepEvent.emit(slug.toLowerCase());
      this.signupService.setComplementaryCompanyStep(substep.slug);
    }
  }

  handleChangeStep(step) {
    // Encontra o índice real do step no array atual
    const stepIndex = this.steps.findIndex((s) => s.title === step.title);

    if (this.stepType === 'person') {
      if (this.isShareholder) {
        switch (step.title) {
          case 'Dados complementares':
            this.signupService.changePersonStepEvent.emit('general');
            this.signupService.setPersonStep('complementaryGeneral');

            this.changeActiveStep.emit(stepIndex);
            break;

          case 'Resumo dos poderes':
            const routeIdPowers = this.route.snapshot.paramMap.get('id');
            if (routeIdPowers) {
              this.signupService.updateUserStepPF('register', 'powers', routeIdPowers);
            }

            this.changeActiveStep.emit(stepIndex);
            break;

          case 'Rendimentos & patrimônios':
            const routeId = this.route.snapshot.paramMap.get('id');
            if (routeId) {
              this.signupService.updateUserStepPF('register', 'income', routeId);
            }
            this.signupService.sendPersonData.emit('income');

            this.changeActiveStep.emit(stepIndex);
            break;

          case 'Declarações & autorizações':
            const routeIdDeclarations = this.route.snapshot.paramMap.get('id');
            if (routeIdDeclarations) {
              this.signupService.updateUserStepPF('register', 'declarations', routeIdDeclarations);
            }

            this.changeActiveStep.emit(stepIndex);
            break;

          case 'Análise de perfil de investidor':
            const routeIdAnalysis = this.route.snapshot.paramMap.get('id');
            if (routeIdAnalysis) {
              this.signupService.updateUserStepPF('register', 'analysis', routeIdAnalysis);
            }

            this.changeActiveStep.emit(stepIndex);
            break;

          case 'Declaração de Condição de Investidor':
            const routeIdConditions = this.route.snapshot.paramMap.get('id');
            if (routeIdConditions) {
              this.signupService.updateUserStepPF('register', 'conditions', routeIdConditions);
            }

            this.changeActiveStep.emit(stepIndex);
            break;

          case 'Declaração US Person / Non US Person (FATCA)':
            const routeIdTax = this.route.snapshot.paramMap.get('id');
            if (routeIdTax) {
              this.signupService.updateUserStepPF('register', 'tax', routeIdTax);
            }

            this.changeActiveStep.emit(stepIndex);
            break;

          case 'Anexos & comprovantes':
            const routeIdAttachments = this.route.snapshot.paramMap.get('id');
            if (routeIdAttachments) {
              this.signupService.updateUserStepPF('register', 'attachments', routeIdAttachments);
            }

            this.changeActiveStep.emit(stepIndex);
            break;

          default:
            break;
        }
      } else {
        switch (step.title) {
          case 'Dados complementares':
            this.signupService.changePersonStepEvent.emit('general');
            this.signupService.setPersonStep('complementaryGeneral');

            this.changeActiveStep.emit(stepIndex);
            break;

          case 'Resumo dos poderes':
            const routeIdPowersNonShareholder = this.route.snapshot.paramMap.get('id');
            if (routeIdPowersNonShareholder) {
              this.signupService.updateUserStepPF('register', 'powers', routeIdPowersNonShareholder);
            }

            this.changeActiveStep.emit(stepIndex);
            break;

          case 'Anexos & comprovantes':
            const routeIdAttachmentsNonShareholder = this.route.snapshot.paramMap.get('id');
            if (routeIdAttachmentsNonShareholder) {
              this.signupService.updateUserStepPF('register', 'attachments', routeIdAttachmentsNonShareholder);
            }

            this.changeActiveStep.emit(stepIndex);
            break;

          default:
            break;
        }
      }
    } else {
      if (this.isShareholder) {
        if (this.isFund) {
          switch (step.title) {
            case 'Dados complementares':
              this.signupService.changeCompanyStepEvent.emit('general');
              this.signupService.setCompanyStep('complementaryGeneral');

              this.changeActiveStep.emit(stepIndex);
              break;

            case 'Declarações & autorizações':
              const routeIdDeclarationsFund = this.route.snapshot.paramMap.get('id');
              if (routeIdDeclarationsFund) {
                this.signupService.updateUserStepPF('register', 'declarations', routeIdDeclarationsFund);
              }

              this.changeActiveStep.emit(stepIndex);
              break;

            case 'Perfil de Investimento do Fundo Cotista':
              const routeIdAnalysisFund = this.route.snapshot.paramMap.get('id');
              if (routeIdAnalysisFund) {
                this.signupService.updateUserStepPF('register', 'analysis', routeIdAnalysisFund);
              }

              this.changeActiveStep.emit(stepIndex);
              break;

            case 'Declaração US Person / Non US Person (FATCA)':
              const routeIdTaxFund = this.route.snapshot.paramMap.get('id');
              if (routeIdTaxFund) {
                this.signupService.updateUserStepPF('register', 'tax', routeIdTaxFund);
              }

              this.changeActiveStep.emit(stepIndex);
              break;

            case 'Anexos & comprovantes':
              const routeIdAttachmentsFund = this.route.snapshot.paramMap.get('id');
              if (routeIdAttachmentsFund) {
                this.signupService.updateUserStepPF('register', 'attachments', routeIdAttachmentsFund);
              }

              this.changeActiveStep.emit(stepIndex);
              break;

            default:
              break;
          }
        } else {
          switch (step.title) {
            case 'Dados complementares':
              this.signupService.changeCompanyStepEvent.emit('general');
              this.signupService.setCompanyStep('complementaryGeneral');

              this.changeActiveStep.emit(stepIndex);
              break;

            case 'Resumo dos poderes':
              const routeIdPowersCompany = this.route.snapshot.paramMap.get('id');
              if (routeIdPowersCompany) {
                this.signupService.updateUserStepPF('register', 'powers', routeIdPowersCompany);
              }

              this.changeActiveStep.emit(stepIndex);
              break;

            case 'Rendimentos & patrimônios':
              const routeId2 = this.route.snapshot.paramMap.get('id');
              if (routeId2) {
                this.signupService.updateUserStepPF('register', 'income', routeId2);
              }
              this.signupService.sendPersonData.emit('income');

              this.changeActiveStep.emit(stepIndex);
              break;

            case 'Declarações & autorizações':
              const routeIdDeclarationsCompany = this.route.snapshot.paramMap.get('id');
              if (routeIdDeclarationsCompany) {
                this.signupService.updateUserStepPF('register', 'declarations', routeIdDeclarationsCompany);
              }

              this.changeActiveStep.emit(stepIndex);
              break;

            case 'Análise de perfil de investidor':
              const routeIdAnalysisCompany = this.route.snapshot.paramMap.get('id');
              if (routeIdAnalysisCompany) {
                this.signupService.updateUserStepPF('register', 'analysis', routeIdAnalysisCompany);
              }

              this.changeActiveStep.emit(stepIndex);
              break;

            case 'Declaração de Condição de Investidor':
              const routeIdConditionsCompany = this.route.snapshot.paramMap.get('id');
              if (routeIdConditionsCompany) {
                this.signupService.updateUserStepPF('register', 'conditions', routeIdConditionsCompany);
              }

              this.changeActiveStep.emit(stepIndex);
              break;

            case 'Declaração US Person / Non US Person (FATCA)':
              const routeIdTaxCompany = this.route.snapshot.paramMap.get('id');
              if (routeIdTaxCompany) {
                this.signupService.updateUserStepPF('register', 'tax', routeIdTaxCompany);
              }

              this.changeActiveStep.emit(stepIndex);
              break;

            case 'Anexos & comprovantes':
              const routeIdAttachmentsCompany = this.route.snapshot.paramMap.get('id');
              if (routeIdAttachmentsCompany) {
                this.signupService.updateUserStepPF('register', 'attachments', routeIdAttachmentsCompany);
              }

              this.changeActiveStep.emit(stepIndex);
              break;

            default:
              break;
          }
        }
      } else {
        switch (step.title) {
          case 'Dados complementares':
            this.signupService.changeCompanyStepEvent.emit('general');
            this.signupService.setComplementaryCompanyStep(
              'complementaryGeneral'
            );

            this.changeActiveStep.emit(stepIndex);
            break;

          case 'Resumo dos poderes':
            const routeIdPowersCompanyNonShareholder = this.route.snapshot.paramMap.get('id');
            if (routeIdPowersCompanyNonShareholder) {
              this.signupService.updateUserStepPF('register', 'powers', routeIdPowersCompanyNonShareholder);
            }
            this.changeActiveStep.emit(stepIndex);

            break;

          case 'Anexos & comprovantes':
            const routeIdAttachmentsCompanyNonShareholder = this.route.snapshot.paramMap.get('id');
            if (routeIdAttachmentsCompanyNonShareholder) {
              this.signupService.updateUserStepPF('register', 'attachments', routeIdAttachmentsCompanyNonShareholder);
            }

            this.changeActiveStep.emit(stepIndex);

            break;

          default:
            break;
        }
      }
    }
  }
}
